<template>
  <div class="importTable">
    <div v-if="isLoadingStart">
      <span
        ><v-progress-circular
          indeterminate
          :size="20"
          color="blue lighten-5"
          class="mr-2"
        ></v-progress-circular
        >Loading...</span
      >
    </div>

    <div>
      <v-alert v-if="startImportResults.Errors" dense outlined type="error" class="mb-8">
        <strong>Some errors occurred during import process</strong>
      </v-alert>

      <v-data-table
        v-if="startImportResults.Results"
        :headers="headersResult"
        :items="startImportResults.Results"
        :items-per-page="-1"
        dense
      >
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImportTable',
  components: {},
  props: { startImportResults: Object, isLoadingStart: Boolean },

  data() {
    return {};
  },

  computed: {
    headersResult() {
      const result = [];
      if (this.startImportResults.Results) {
        for (let prop in this.startImportResults.Results[0]) {
          result.push({ text: prop, value: prop });
        }
      }
      return result;
    },
  },

  methods: {},
};
</script>

<style lang="scss">
.importTable {
  
  .v-data-table tbody tr {
    cursor: default;
  }
}
</style>
